<div [ngClass]="{'fx-justify-end': isNumericalColumn ,'fx-justify-space-between': !isNumericalColumn}"
     class="ag-cell-editor fx-layout-row fx-justify-center fx-gap-5">
  <div>
    {{ params.valueFormatted }}
  </div>
  <div>
    <mat-icon fontSet="mdi" fontIcon="mdi-pencil" aria-hidden="true" class="tooltip-icon"></mat-icon>
  </div>
</div>